import { faRouter } from '@apps/fa';
import { systemManagementRouter } from '@apps/system-management';
import { useEffect, useState } from 'react';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { GlobalContainer, ShellContainer } from './layouts';
import { AdminLogin } from './pages/AdminLogin';
import { AuthCallbackPage } from './pages/AuthCallBack';
import { AuthErrorView } from './pages/AuthErrorView';
import { ErrorBoundary } from './pages/ErrorBoundary';
import { Login } from './pages/Login';
import { SandboxLogin } from './pages/SandboxLogin';
import { TopPage } from './pages/TopPage';
import { userRouter } from './userRouter';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<ShellContainer />}>
        <Route index element={<TopPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/sandbox-login" element={<SandboxLogin />} />
        <Route
          path="/user/change-password/first-time"
          lazy={async () => import('./pages/FirstTimeChangePassword')}
        />
      </Route>
      <Route path="/callback" element={<AuthCallbackPage />} />
      <Route path="/error" element={<AuthErrorView />} />
      <Route element={<GlobalContainer />} errorElement={<ErrorBoundary />}>
        {userRouter}
        {systemManagementRouter}
        {faRouter}
      </Route>
    </>,
  ),
);

function Shell() {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [hasScriptError, setHasScriptError] = useState(false);

  useEffect(() => {
    if (!process.env.PENDO_API_KEY) {
      setIsScriptLoaded(true);
    } else {
      const src = `https://cdn.pendo.io/agent/static/${process.env.PENDO_API_KEY}/pendo.js`;
      const existingScript = document.querySelector(`script[src="${src}"]`);
      if (existingScript) {
        setIsScriptLoaded(true);
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => setIsScriptLoaded(true);
      script.onerror = () => setHasScriptError(true);
      document.head.appendChild(script);
    }
  }, []);

  if (hasScriptError) {
    return (
      <div>Failed to load external script, please refresh the page or contact system administrator.</div>
    );
  }
  if (!isScriptLoaded) {
    return null;
  }

  return <RouterProvider router={router} />;
}

export { Shell };
